import { BASE_URL } from './Config.js';

export class UserService {
  getCurrentUser = async () => {
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      throw new Error("NO_TOKEN");
    }

    //vers le nouvel endpoint /profile
    const response = await fetch(`${BASE_URL}/user/profile`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("SESSION_EXPIRED");
    }
    
    if (!response.ok) {
      throw new Error("FETCH_FAILED");
    }

    return await response.json();
  }
}